import React from 'react';
import PaginationTable from '../PaginationTable';
import {formatDate, formatMoney, numberPadding } from '../../../utils/formatting';
import Filters from './Filters';

export default class ProductsReport extends React.Component {

    constructor(props) {
        super(props);
        this.fetchReports = this._fetchReports.bind(this);
        this.filterChange = this._filterChange.bind(this);
        this.state = {
            filters : {}
        };
    }

    componentWillMount() {
        this.fetchReports();
    }

    _filterChange(data) {
        this.setState({
            filters : data,
        }, this.fetchReports);
    } 

    _fetchReports(page) {
        this.props.fetchReports('products', page, this.state.filters);
    }

    render() {
        const data = this.props.reportsState.products;
        const paginationData = data ? data.data : {};
        return (
            <div>
                <Filters 
                    requestXlsx={this.props.requestXlsx}
                    report="products"
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    users={this.props.users}  
                    onFilterChange={this.filterChange}  
                />
                {
                    (data||{}).fetching ?
                        <div className="container my-2">
                            <i className="fa fa-spinner fa-spin"></i> Cargando
                        </div>
                    :
                        <PaginationTable {...paginationData}
                        territories={this.props.territories}
                        coordinations={this.props.coordinations}
                        pageChange={this.fetchReports}
                        headerComponent={renderHeader}
                        rowComponent={renderRow}/>
                }
                
            </div>
        );
    }
}

function renderHeader(props) {
    return (
        <tr>
            <th>
                Territorio
            </th>
            <th>
                Coordinación
            </th>   
            <th>
                SIC
            </th>
            <th>
                Nombre cliente
            </th>
            <th>
                No. ejecutivo
            </th>
            <th>
                Nombre ejecutivo
            </th>
            <th>
                Producto
            </th>
            <th>
                Monto
            </th>
            <th>
                Fecha de solicitud
            </th>
        </tr>
    );
} 

function renderRow(props) {
    const report = props.item;
    const territory = props.territories.data[report.user.territory_id];
    const coordination = props.coordinations.data[report.user.coordination_id];
    return (
        <tr>
            <td>
                {territory ? territory.name : 'Desconocido'}
            </td>
            <td>
                {coordination ? coordination.name : 'Desconocida'}
            </td>
            <td>
                {report.client.sic}
            </td>
            <td>
                {report.client.full_name}
            </td>
            <td>
                {numberPadding(report.user.emp_number, 6)}
            </td>
            <td>
                {report.user.name}
            </td>
            <td>
                {report.product.name}
            </td>
            <td className="text-xs-right">
                {formatMoney(report.amount)}
            </td>
            <td>
                {formatDate(report.created_at)}
            </td>
        </tr>
    );    
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/ProductsReport.jsx
 **/